export default  {
	id: '',
	name: '',
	property: '',
	acreage: '',
	section_id: null,
	type: null,
	owner: '',
	transfer_date: ''
}